import { equals } from 'ramda';
import { UUID } from '@/types';
import ColumnName from '@/util/ColumnName';
import DashboardWidget from './DashboardWidget';

class DashboardChartWidget extends DashboardWidget {
  isPreview = false;

  constructor(
    readonly series: Nullable<UUID>,
    key: string | number,
    x: number,
    y: number,
    width: number,
    height: number,
    displayType: string,
    readonly widgetTitle: Nullable<string> = null,
    readonly chartSetting: Nullable<string> = null,
    readonly metricColumns: Nullable<ColumnName[]> = null,
    readonly dimensionColumns: Nullable<ColumnName[]> = null,
    unit = 1,
  ) {
    super(key, x, y, width, height, displayType, unit);
    this.widgetTitle = widgetTitle;
    this.chartSetting = chartSetting;
    this.metricColumns = metricColumns;
    this.dimensionColumns = dimensionColumns;
  }

  setIsPreview(val: boolean) {
    this.isPreview = val;

    return this;
  }

  static create = (
    ...args: ConstructorParameters<typeof DashboardChartWidget>
  ) => new DashboardChartWidget(...args);

  static fromJson = (
    w: AddUnderscorePrefix<
      DashboardChartWidget,
      'widgetTitle' | 'chartSetting' | 'metricColumns' | 'dimensionColumns'
    >,
  ) =>
    new DashboardChartWidget(
      w._series,
      w._key,
      w._x,
      w._y,
      w._width,
      w._height,
      w._displayType,
      w.widgetTitle,
      w.chartSetting,
      w.metricColumns,
      w.dimensionColumns,
      w._unit,
    );

  static toJson = (
    w: DashboardChartWidget,
  ): Omit<
    AddUnderscorePrefix<
      DashboardChartWidget,
      'widgetTitle' | 'chartSetting' | 'metricColumns' | 'dimensionColumns'
    >,
    '_isPreview'
  > => ({
    _series: w.series,
    _key: w.key,
    _x: w.x,
    _y: w.y,
    _width: w.width,
    _height: w.height,
    _displayType: w.displayType,
    _unit: w.unit,
    widgetTitle: w.widgetTitle,
    chartSetting: w.chartSetting,
    metricColumns: w.metricColumns,
    dimensionColumns: w.dimensionColumns,
  });

  equals(w: DashboardChartWidget) {
    if (!w) {
      return false;
    }
    if (w === this) {
      return true;
    }
    return (
      w.key === this.key &&
      w.x === this.x &&
      w.y === this.y &&
      w.width === this.width &&
      w.height === this.height &&
      w.series === this.series &&
      w.displayType === this.displayType &&
      w.widgetTitle === this.widgetTitle &&
      equals(w.chartSetting, this.chartSetting) &&
      equals(w.metricColumns, this.metricColumns) &&
      equals(w.dimensionColumns, this.dimensionColumns)
    );
  }
}

export default DashboardChartWidget;
